import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { ListingCard, NamedLink } from '../../../components';
import SectionHeader from './SectionHeader';

import css from './Sections.module.css';

// The newest listings shown beside the card that leads to all of them
const SHOWN = 3;
const NEWEST_FIRST = { search: '?sort=createdAt' };

const ArrowRight = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

/**
 * Just in: the newest listings, and a card to all new listings. A row of four from tablet
 * up; on a phone the listings scroll sideways and the link follows them.
 */
function ExploreSection(props) {
  const { listings, intl } = props;

  if (!listings || listings.length === 0) {
    return null;
  }

  return (
    <section className={css.section}>
      <div className={css.container}>
        <div className={css.sectionHead}>
          <SectionHeader
            eyebrow={intl.formatMessage({ id: 'ExploreSection.eyebrow' })}
            title={intl.formatMessage({ id: 'ExploreSection.justIn' })}
          />
          <NamedLink name="SearchPage" to={NEWEST_FIRST} className={css.headerLinkWide}>
            <FormattedMessage id="ExploreSection.seeAll" />
            <ArrowRight />
          </NamedLink>
        </div>
        <ul className={css.justIn}>
          {listings.slice(0, SHOWN).map(l => (
            <li key={l?.id?.uuid} className={css.justInItem}>
              <ListingCard className={css.justInCard} listing={l} setActiveListing={() => {}} />
            </li>
          ))}
          <li className={css.justInMore}>
            <NamedLink name="SearchPage" to={NEWEST_FIRST} className={css.newCard}>
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.4"
                aria-hidden="true"
              >
                <path d="M9 18V6l11-2v12" />
                <circle cx="6" cy="18" r="3" />
                <circle cx="17" cy="16" r="3" />
              </svg>
              <span className={css.newCardText}>
                <span className={css.newCardTitle}>
                  <FormattedMessage id="ExploreSection.newCardTitle" />
                </span>
                <span className={css.newCardLink}>
                  <FormattedMessage id="ExploreSection.newCardLink" />
                  <ArrowRight />
                </span>
              </span>
            </NamedLink>
          </li>
        </ul>
        <NamedLink name="SearchPage" to={NEWEST_FIRST} className={css.headerLinkNarrow}>
          <FormattedMessage id="ExploreSection.seeAll" />
          <ArrowRight />
        </NamedLink>
      </div>
    </section>
  );
}

export default ExploreSection;
